export function buttonActionFunc() {
  let accordionBox = $('.accordionJs');
  accordionBox.find('dt').on('click', function () {
    $(this).toggleClass('selected').next('dd').slideToggle();
  });

  //タブ切り替え
  $('.tab li').click(function () {
    var index = $('.tab li').index(this);
    $('.topicon > div').css('display', 'none');
    $('.topicon > div').eq(index).fadeIn("slow");
    $('.tab li').removeClass('select');
    $(this).addClass('select')
  });

  //タブ切り替え
  $('.tabNews li').click(function () {
    var index = $('.tabNews li').index(this);
    $('.topiconNews > div').css('display', 'none');
    $('.topiconNews > div').eq(index).fadeIn("slow");
    $('.tabNews li').removeClass('select');
    $(this).addClass('select')
  });

  //資料ダウンロード後の設定
//  document.addEventListener('wpcf7mailsent', function (event) {
//    $.ajax({
//      type: 'POST',
//      url: ajaxurl,
//      data: {
//        'action': 'documentMore',
//        'id': id,
//      },
//      success: function (response) {
//        $('.posPop').fadeIn();
//        $('.contactForm').remove();
//        $('.wpDefaultEditor').removeClass('intermediate');
//        $('#jsMore').html(response).addClass('more');
//        window.scrollTo(0, 0);
//      },
//      error: function () {
//        //失敗した時の処理
//        alert("通信に失敗しました。リロードしてください。");
//      }
//    });
//    return false;
//  }, false);
  $('.close').on('click', function () {
    $('.posPop').fadeOut();
  });
  $('.overlay').on('click', function () {
    $('.posPop').fadeOut();
  });
  $('.tagWrapEle').on('click', function () {
    let resizecheck = $('#responsibleCheck').width();
    if (resizecheck == 2) {
      $(this).find('h3').toggleClass('open');
      $(this).find('ul').slideToggle();
    }
  });
}